var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVector = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24988 2.96905H5.40457V8.25499C5.40457 8.32374 5.46082 8.37999 5.52957 8.37999H6.46707C6.53582 8.37999 6.59207 8.32374 6.59207 8.25499V2.96905H7.74988C7.85457 2.96905 7.91238 2.84874 7.84832 2.76749L6.09832 0.551867C6.08662 0.536927 6.07168 0.524844 6.05463 0.516534C6.03757 0.508225 6.01885 0.503906 5.99988 0.503906C5.98091 0.503906 5.96218 0.508225 5.94513 0.516534C5.92807 0.524844 5.91313 0.536927 5.90144 0.551867L4.15144 2.76593C4.08738 2.84874 4.14519 2.96905 4.24988 2.96905ZM11.7186 7.78624H10.7811C10.7124 7.78624 10.6561 7.84249 10.6561 7.91124V10.3175H1.34363V7.91124C1.34363 7.84249 1.28738 7.78624 1.21863 7.78624H0.281128C0.212378 7.78624 0.156128 7.84249 0.156128 7.91124V11.005C0.156128 11.2816 0.379565 11.505 0.656128 11.505H11.3436C11.6202 11.505 11.8436 11.2816 11.8436 11.005V7.91124C11.8436 7.84249 11.7874 7.78624 11.7186 7.78624Z",
    fill: "black",
    fillOpacity: 0.85
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVector, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Vector.d11fa79e.svg";
export { ForwardRef as ReactComponent };